import template from './template.html'

angular.module('contabilidad.polizas')
  .config(function ($dialogProvider) {
    $dialogProvider.dialog('contabilidad.polizas.exportar', {
      template,
      controllerAs: '$ctrl',
      controller: 'ContabilidadPolizasExportar',
    })
  })
  .controller('ContabilidadPolizasExportar', ContabilidadPolizasExportarController)

function colapsarLista (lista) {
  return lista.slice(0, 5)
      .join(', ')
    + (lista.length > 5 ? ', y ' + (lista.length - 5) + ' más' : '')
}

function ContabilidadPolizasExportarController (exportarService, dialog, $dialogParams, $notify) {
  var $ctrl = this
  $ctrl.data = $dialogParams.data
  $ctrl.fecha_inicio = $dialogParams.fecha_inicio
  $ctrl.config = $dialogParams.config
  $ctrl.opciones = {
    inicio_poliza: 1,
    archivo: $ctrl.config.archivo,
  }

  this.cancelar = function () {
    dialog.reject()
  }

  this.exportar = function () {
    var respuesta = exportarService.exportarPoliza($ctrl.data, $ctrl.opciones.inicio_poliza, $ctrl.opciones.archivo, $ctrl.config.tipo_poliza, $ctrl.fecha_inicio, $ctrl.config.nominas)

    if (respuesta === 'Error') {
      $notify.error('Error al general la póliza.')
    } else {
      dialog.resolve('respuesta')
    }
  }

  this.generarTexto = function () {
    switch ($ctrl.config.tipo_poliza) {
      case 'facturacion':
      case 'facturacioncanceladas':
      case 'provisionpagos':
      case 'provisionIngresosPagos':
      case 'gastosNoDeducibles':
      case 'provisionGastosPagos':
        if (!Array.isArray($ctrl.config.clientes)) {
          $ctrl.config.clientes = [{nombre: $ctrl.config.clientes}]
        }
        var clientes = $ctrl.config.clientes.map(function (item) {
          return (item.nombre || item.Nombre).trim()
        })

        $ctrl.texto = 'Se exportarán las pólizas ' + (clientes.length > 1 ? 'de los clientes ' : 'del cliente ')
          + colapsarLista(clientes) + '.'
        break

      case 'provisionNominaconpagos':
      case 'provisionNomina':
      case 'pagosNominaMXN':
      case 'pagosNominaUSD':
        if (!Array.isArray($ctrl.config.nominas)) {
          $ctrl.config.nominas = [{id_nomina: $ctrl.config.nominas}]
        }
        var nominas = $ctrl.config.nominas.map(function (item) {
          return (item.id_nomina || item.ID_Nomina).trim()
        })

        $ctrl.texto = 'Se exportarán las pólizas ' + (nominas.length > 1 ? 'de las nóminas ' : 'de la nómina ')
          + colapsarLista(nominas) + '.'
        break

      default:
        $ctrl.texto = ''
    }
  }

  this.generarTexto()
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/exportar/component.js